module.exports = __webpack_public_path__ + "img/t5-c7.1e12f852.png";